import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sizeLabel", "penHelp", "syringeHelp", "concentration"];
  static values = { pen: Boolean };

  connect() {
    this.refresh();
  }

  refresh() {
    const device = this.element.querySelector('input[name="vial[device]"]:checked')?.value;
    const pen = device ? device === "pen" : this.penValue;
    if (this.hasSizeLabelTarget) {
      this.sizeLabelTarget.textContent = pen ? "Pen" : "Syringe";
      this.penHelpTarget.hidden = !pen;
      this.syringeHelpTarget.hidden = pen;
    }
    if (!this.hasConcentrationTarget) return;

    const amount = Number(this.element.elements.namedItem("vial[powder_amount]").value);
    const volume = Number(this.element.elements.namedItem("vial[water_volume_ml]").value);
    const concentration = amount / volume;
    const valid = amount > 0 && volume > 0 && Number.isFinite(concentration);
    this.concentrationTarget.hidden = !valid;
    if (valid) {
      const unit = this.element.elements.namedItem("vial[powder_unit]").value;
      this.concentrationTarget.textContent = `Concentration: ${Number(concentration.toFixed(4))} ${unit}/mL`;
    }
  }
}
